import { openBlock as t, createElementBlock as l, createStaticVNode as a } from "vue";
const e = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, h = /* @__PURE__ */ a('<path fill="#FCFCFC" d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"></path><path fill="#A2001D" d="m8.261 18.55-2.174-3.943 2.174-3.882 2.174 3.882L8.26 18.55Z"></path><path fill="#A2001D" d="M3.913 18.55 1.74 14.608l2.174-3.882 2.174 3.882-2.174 3.944Zm4.348 10.725-2.174-3.944 2.174-3.882 2.174 3.882-2.174 3.944Z"></path><path fill="#A2001D" d="M3.913 29.275 1.74 25.331l2.174-3.882 2.174 3.882-2.174 3.944Zm6.522-25.393-.616-1.099a20.054 20.054 0 0 0-3.093 2.259l1.535 2.784 2.174-3.944ZM8.261 32.174l-1.551 2.77a20.055 20.055 0 0 0 3.091 2.262l.634-1.15-2.174-3.882Z"></path><path fill="#6DA544" d="M12.174 25.217V38.41A19.933 19.933 0 0 0 20 40c8.6 0 15.93-5.428 18.756-13.044l-26.582-1.739Z"></path><path fill="#A2001D" d="M38.756 26.956A19.955 19.955 0 0 0 40 20C40 8.954 31.046 0 20 0a19.94 19.94 0 0 0-7.826 1.59v25.367h26.582Z"></path>', 6), o = [
  h
];
function p(c, i) {
  return t(), l("svg", e, [...o]);
}
const d = { render: p };
export {
  d as default,
  p as render
};
